import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42c79714")

_pushScopeId("data-v-42c79714")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Text Editor")
const _hoisted_2 = { class: "fill mt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    cancel: _withId(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn",
        onClick: _ctx.cancel
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Cancel'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    confirm: _withId(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn primary",
        onClick: _ctx.ok
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'OK'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("textarea", {
          draggable: false,
          class: "d-text br-lg",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.text = $event))
        }, null, 512), [
          [_vModelText, _ctx.text]
        ])
      ])
    ]),
    _: 1
  }))
})